import React from "react";
import {Grid, FormControl, TextField, Typography} from "@mui/material";
import {removeInitialSpecialChars} from "../../../util/sanitizeUtil";

interface DriverInfoFormProps {
  driverFirstName: string;
  driverLastName: string;
  driverLicenseNumber: string;
  setDriverFirstName: (value: string) => void;
  setDriverLastName: (value: string) => void;
  setDriverLicenseNumber: (value: string) => void;
  required?: boolean;
}

const DriverInfoForm = ({
                          driverFirstName,
                          driverLastName,
                          driverLicenseNumber,
                          setDriverFirstName,
                          setDriverLastName,
                          setDriverLicenseNumber,
                          required
                        }: DriverInfoFormProps) => {

  return <Grid item container component={'section'} marginTop={"1em"} spacing={2} direction={"column"}>
    <Grid item>
      <Typography variant={'h6'} color={'textPrimary'}>Driver Details</Typography>
    </Grid>
    <Grid item>
      <FormControl fullWidth>
        <TextField
          id="ss-select-correction-driver-first"
          value={driverFirstName}
          type="text"
          name="driverFirst"
          onChange={({target}) => setDriverFirstName(removeInitialSpecialChars(target.value))}
          label="First Name"
          required={required}
        />
      </FormControl>
    </Grid>

    <Grid item>
      <FormControl fullWidth>
        <TextField
          id="ss-select-correction-driver-last"
          value={driverLastName}
          type="text"
          name="driverLast"
          onChange={({target}) => setDriverLastName(removeInitialSpecialChars(target.value))}
          label="Last Name"
          required={required}
        />
      </FormControl>
    </Grid>

    <Grid item>
      <FormControl fullWidth>
        <TextField
          id="ss-select-correction-driver-license"
          value={driverLicenseNumber}
          type="text"
          name="driverLicense"
          onChange={({target}) => setDriverLicenseNumber(removeInitialSpecialChars(target.value))}
          label="License Number"
          required={required}
        />
      </FormControl>
    </Grid>
  </Grid>

}

export default DriverInfoForm;
